import { Button, Grid, Tooltip } from '@material-ui/core';
import { EChargeType } from 'interfaces/IEditProduct';
import React from 'react';
import { Link } from 'react-router-dom';

import type IProduct from 'interfaces/IProduct';

type SectionMoreProps = {
  product: IProduct;
};

function SectionMore({ product }: SectionMoreProps) {
  return (
    <>
      <Grid item xs={12} md={4}>
        <div className='card-more'>
          <img src='/img/icon_psl.svg' width='40' />
          <strong>Configure o PSL</strong>
          <p>Agora você pode configurar os planos para que seus clientes tenham a liberdade e flexibilidade de escolha.</p>
          <div>
            <Link id='link-go-to-psl' to={`/producer/product/editproduct/${product.id}/paymentmethods`}>
              <Button variant='outlined'>Configurar</Button>
            </Link>
          </div>
        </div>
      </Grid>

      <Grid item xs={12} md={4}>
        <div className='card-more'>
          <img src='/img/icon_offer.svg' width='40' />
          <strong>Crie ofertas</strong>
          <p>Você pode criar ofertas para todos os planos, tornando-os mais atrativos para seus clientes.</p>
          <div>
            <Link id='link-go-to-offer' to={`/producer/product/editproduct/${product.id}/sales`}>
              <Button variant='outlined'>Criar oferta</Button>
            </Link>
          </div>
        </div>
      </Grid>

      <Grid item xs={12} md={4}>
        <div className='card-more'>
          <img src='/img/icon_affiliate.svg' width='40' />
          <strong>Comissões para afiliados</strong>
          <p>Configure a porcentagem que seu afiliado receberá por cada plano vendido.</p>
          <div>
            <Tooltip
              placement='top'
              title='O recurso de afiliado está indisponível para produtos gratuitos'
              disableFocusListener={product.charge_type !== EChargeType.FREE}
              disableHoverListener={product.charge_type !== EChargeType.FREE}
              disableTouchListener={product.charge_type !== EChargeType.FREE}
            >
              <div style={{ display: 'inline-block' }}>
                <Button
                  component={Link}
                  id='link-go-to-affiliate'
                  to={`/producer/product/editproduct/${product.id}/affiliates`}
                  variant='outlined'
                  disabled={product.charge_type === EChargeType.FREE}
                >
                  Habilitar comissão
                </Button>
              </div>
            </Tooltip>
          </div>
        </div>
      </Grid>
    </>
  );
}

export default SectionMore;
